import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Heart, Share2 } from 'lucide-react';
import { getEntityImageUrl, makeImageFallback } from '@/lib/entityMedia';

const HERO_FALLBACK = 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=1200';

const EntityHero = ({ entity, saved, onBack, onSave, onShare }) => {
  return (
    <div className="relative h-56 sm:h-72 md:h-96">
      <img
        src={getEntityImageUrl(entity, { width: 1200 }) || HERO_FALLBACK}
        alt={entity.name}
        className="w-full h-full object-cover"
        onError={makeImageFallback(entity, HERO_FALLBACK)}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent" />

      {/* Back Button */}
      <Button
        variant="secondary"
        size="icon"
        className="absolute top-4 left-4 rounded-full glass"
        onClick={onBack}
        data-testid="entity-back-btn"
      >
        <ArrowLeft className="h-5 w-5" />
      </Button>

      {/* Action Buttons */}
      <div className="absolute top-4 right-4 flex gap-2">
        <Button
          variant="secondary"
          size="icon"
          className="rounded-full glass"
          onClick={onSave}
          data-testid="entity-save-btn"
        >
          <Heart className={`h-5 w-5 ${saved ? 'fill-red-500 text-red-500' : ''}`} />
        </Button>
        <Button
          variant="secondary"
          size="icon"
          className="rounded-full glass"
          onClick={onShare}
          data-testid="entity-share-btn"
        >
          <Share2 className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
};

export default EntityHero;
